import React from "react";
import { Box, Typography, Grid } from "@mui/material";

const statsBoxStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  padding: "20px",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "120px", // Ensures all boxes have a minimum height
};

const statistics = [
    { value: "100%", label: "Customer Satisfaction" },
    { value: "15+", label: "Projects Delivered" },
    { value: "3+", label: "Industries Served" },
  ];
  

const OurNumbers = ({  title = " Numbers That Define Our Excellence" }) => {
  return (
    <Box sx={{ textAlign: "center", marginTop: "50px" }}>
      <Typography variant="h5" fontWeight="bold">
        {title}
      </Typography>
      <Grid container spacing={3} sx={{ marginTop: "20px", justifyContent: "center" }}>
        {statistics.map((stat, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Box sx={statsBoxStyle}>
              <Typography variant="h3" fontWeight="bold" sx={{ color: "black" }}>
                {stat.value}
              </Typography>
              <Typography variant="body1" sx={{ color: "#222" }}>
                {stat.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default OurNumbers;
